import React, { useContext } from "react";
import { AppContext } from "./app";
import { LoginPage, ImageBlock, LoginBlock as Choices } from "./login";
import Grid from "./components/layout/grid";
import styled from "styled-components";
import { Button } from "./components/base_ui/inputs/button";
import { ParagraphMedium } from "baseui/typography";

const Title = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.sizing.scale700};
  font-size: ${({ theme }) => theme.typography.HeadingSmall.fontSize};
  font-weight: ${({ theme }) => theme.typography.HeadingSmall.fontWeight};
  line-height: ${({ theme }) => theme.typography.HeadingSmall.lineHeight};
  color: ${({ theme }) => theme.colors.contentPrimary};
`;

const Buttons = styled.div`
  margin-top: ${({ theme }) => theme.sizing.scale500};
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${({ theme }) => theme.sizing.scale500};
  row-gap: ${({ theme }) => theme.sizing.scale500};
  @media ${({ theme }) => theme.deprecatedBreakpoints.medium} {
    grid-template-columns: none;
    column-gap: none;
    grid-template-rows: 1fr 1fr;
    row-gap: ${({ theme }) => theme.sizing.scale500};
  }
`;

const StyledParagraphMedium = styled(ParagraphMedium)`
  margin-top: ${({ theme }) => theme.sizing.scale500};
  margin-bottom: ${({ theme }) => theme.sizing.scale500};
`;

export default function RegistrationOptions() {
  const { school } = useContext(AppContext);

  return (
    <LoginPage>
      <Grid>
        <ImageBlock animateOnHover={false}>
          {school?.logo && <img className="schoolLogo" src={school.logo} alt={`${school.name}`} />}
          <img className="image" src="/images/mc_logo_full.png" alt="Mentor Collective" />
        </ImageBlock>
        {school?.ssoMenteeRecruitmentLinkData?.length &&
        school?.ssoMentorRecruitmentLinkData?.length ? (
          <Choices>
            <Title>Sign Up</Title>
            <Buttons>
              {school?.ssoMenteeRecruitmentLinkData?.map((datum) => (
                <Button key={datum.name} href={datum.link}>
                  {datum.name} as {datum.entityLabel || "Mentee"}
                </Button>
              ))}
              {school?.ssoMentorRecruitmentLinkData?.map((datum) => (
                <Button key={datum.name} href={datum.link}>
                  {datum.name} as {datum.entityLabel || "Mentor"}
                </Button>
              ))}
            </Buttons>
          </Choices>
        ) : (
          <Choices>
            <Title>No Account Found</Title>
            <div>
              <StyledParagraphMedium>
                We can't find an account associated with your email address and there are no
                programs open for registration right now.
              </StyledParagraphMedium>
              <StyledParagraphMedium>
                If you think you may be eligible to register for a program, please check your email
                for a registration link.
              </StyledParagraphMedium>
            </div>
          </Choices>
        )}
      </Grid>
    </LoginPage>
  );
}
